/**
 * The rules for a new password, mirrored from the API
 * (pms-api-v2 `src/user/password-policy.ts`, which is the one that decides) so
 * the pages can show a live checklist. Keep the two in step.
 */
export const PASSWORD_MIN_LENGTH = 10;
export const PASSWORD_MAX_LENGTH = 64;

const COMMON_PASSWORD_WORDS = [
    'password', 'passw0rd', 'motdepasse', 'contrasena', 'ardealy', 'admin', 'welcome', 'bienvenue',
    'letmein', 'qwerty', 'azerty', 'abc123', '123456', 'iloveyou', 'secret', 'changeme', 'default',
];

export type PasswordRule = 'length' | 'lowercase' | 'uppercase' | 'digit' | 'symbol' | 'common';
export const PASSWORD_RULES: PasswordRule[] = ['length', 'lowercase', 'uppercase', 'digit', 'symbol', 'common'];

const unleet = (s: string) =>
    s.toLowerCase().replace(/0/g, 'o').replace(/1/g, 'l').replace(/3/g, 'e').replace(/4/g, 'a').replace(/[5$]/g, 's').replace(/@/g, 'a');

/** Which rules this password meets. */
export function passwordChecks(password: string): Record<PasswordRule, boolean> {
    const pw = password || '';
    const plain = pw.toLowerCase();
    const swapped = unleet(pw);
    return {
        length: pw.length >= PASSWORD_MIN_LENGTH && pw.length <= PASSWORD_MAX_LENGTH,
        lowercase: /[a-z]/.test(pw),
        uppercase: /[A-Z]/.test(pw),
        digit: /[0-9]/.test(pw),
        symbol: /[^A-Za-z0-9]/.test(pw),
        common: pw !== '' && !COMMON_PASSWORD_WORDS.some((w) => plain.includes(w) || swapped.includes(w)),
    };
}

export const isStrongPassword = (password: string) => Object.values(passwordChecks(password)).every(Boolean);
